import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UserBalance from '../../../components/_molecules/UserBalance/UserBalance';
import RefillBalance from '../../../components/_molecules/RefillBalance/RefillBalance';
import UserCardInfo from '../../../components/_molecules/UserCardInfo/UserCardInfo';
import UserInvoiceInfo from '../../../components/_molecules/UserInvoiceInfo/UserInvoiceInfo';
import './BalancePart.scss';
import UserBalanceHistory from '../../../components/_molecules/UserBalanceHistory/UserBalanceHistory';
import LoadingOverlay from '../../../components/_molecules/LoadingOverlay/LoadingOverlay';
import ErrorModal from '../../../components/_molecules/ErrorModal/ErrorModal';
import SuccessModal from '../../../components/_molecules/SuccessModal/SuccessModal';
import { ERROR, SUCCESS, LOADING } from '../../../utils/constants';


// const propTypes = {

// };

class BalancePart extends Component {
  static propTypes = {
    balance: PropTypes.shape({
      amount: PropTypes.number,
    }).isRequired,
    cardMethod: PropTypes.shape({}),
    invoiceMethod: PropTypes.shape({}),
    getApps: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    apps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    currentAppCampaigns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getAppCampaigns: PropTypes.func.isRequired,
    getBalanceHistory: PropTypes.func.isRequired,
    hasMoreBalanceHistory: PropTypes.bool.isRequired,
    balanceHistory: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    balanceHistoryPage: PropTypes.number.isRequired,
    getAppCampaignsStatus: PropTypes.string.isRequired,
    resetBalanceHistory: PropTypes.func.isRequired,
    refillBalance: PropTypes.func.isRequired,
    refillBalanceStatus: PropTypes.string.isRequired,
    annulStoreErrors: PropTypes.func.isRequired,
    refillBalanceError: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
  };
  static defaultProps = {
    cardMethod: {},
    invoiceMethod: {},
  };
  state = {};

  componentWillMount() {
    const { id, getApps } = this.props;
    getApps({ clientId: id, projection: 'SHORT' });
  }
  componentWillUnmount() {
    this.props.resetBalanceHistory();
  }
  render() {
    const {
      balance: { amount },
      cardMethod,
      invoiceMethod,
      apps,
      currentAppCampaigns,
      getAppCampaigns,
      getBalanceHistory,
      hasMoreBalanceHistory,
      balanceHistory,
      balanceHistoryPage,
      getAppCampaignsStatus,
      refillBalance,
      refillBalanceStatus,
      annulStoreErrors,
      refillBalanceError,
      fullName,
      id,
    } = this.props;
    const isError = refillBalanceStatus === ERROR;
    const isSuccess = refillBalanceStatus === SUCCESS;
    const isLoading = refillBalanceStatus === LOADING;
    return (
      <div className="admin-screen-user-balance">
        <LoadingOverlay visible={isLoading} />
        <ErrorModal
          visible={isError}
          error={refillBalanceError}
          requestClose={annulStoreErrors}
        />
        <SuccessModal
          visible={isSuccess}
          text={`Balance of user ${fullName} successfully updated`}
          buttonClick={annulStoreErrors}
        />
        <div className="top-part">
          <UserBalance amount={amount} isAdmin />
          <RefillBalance
            refillBalance={refillBalance}
            refillBalanceStatus={refillBalanceStatus}
            id={id}
            isAdmin
          />
          <div className="billing-info-wrapper">
            <div className="middle-text">
              <span>Billing Info</span>
            </div>
            {cardMethod.active && (
              <UserCardInfo
                clickChangeHandler={this.navigateToChange}
                lastFour={cardMethod.lastFour}
                isAdmin
              />
            )}
            {invoiceMethod.active && (
              <UserInvoiceInfo
                invoiceMethod={invoiceMethod}
                isAdmin
                clickChangeHandler={this.navigateToChange}
              />
            )}
            {!cardMethod.active && !invoiceMethod.active && (<div className="plain-text"> <span>User doesn&apos;t have payment method...</span> </div>)}
          </div>
        </div>

        <UserBalanceHistory
          currentAppCampaigns={currentAppCampaigns}
          apps={apps}
          id={id}
          getAppCampaigns={getAppCampaigns}
          getBalanceHistory={getBalanceHistory}
          balanceHistory={balanceHistory}
          hasMoreBalanceHistory={hasMoreBalanceHistory}
          page={balanceHistoryPage}
          getAppCampaignsStatus={getAppCampaignsStatus}
          refillBalanceStatus={refillBalanceStatus}
        />
      </div>
    );
  }
}

export default BalancePart;



// WEBPACK FOOTER //
// ./src/containers/AdminUserScreen/BalancePart/BalancePart.js